<template>
    <v-overlay>
        <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
</template>

<script>
    import {computed, onMounted} from '@vue/composition-api';
    import {DateTime} from "luxon";
    import XLSX from 'xlsx';
    import eConfig from "../../evention-config.js";
    import axios from 'axios';

    export default {
        name: 'EventReportGeneral',
        setup(props, {root}) {
            const {Event} = root.$FeathersVuex.api;

            const eventId = computed(() => root.$route.params.eventId);
            const dbColMapping = eConfig.reportGeneral.dbColMapping;
            
            const exportReport = async () => {
                const event = await Event.get(eventId.value);

                let stats;
                try {
                    const prefixUrl = process.env.VUE_APP_SERVER_ADDRESS;
                    stats = await axios.create({
                        headers: {'Authorization': window.localStorage.getItem('feathers-jwt')}
                    }).post(`${prefixUrl}/report-api/general`, {
                        eventId: eventId.value,
                        companyId: event.companyId
                    });
                } catch (e) {
                    root.$handleFeatherError(e);
                }
                
                let excelData = [[]];
                for (const value of Object.values(dbColMapping)) {
                    excelData[0].push(stats.data[value]);
                }
                
                excelData.unshift([...Object.keys(dbColMapping)]);
                const ws = XLSX.utils.aoa_to_sheet(excelData);
                const wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, ws, event.name);
                XLSX.writeFile(wb, 'general_report_'+eventId.value+'_'+DateTime.local().toFormat('yyyyMMdd_HHmmss')+'.xlsx');
                
                root.$router.go(-1);
            }
            
            onMounted(() => {
                exportReport();
            });

            return {
            }
        },
    }
</script>
